/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from "react";
import { getProfileInfo } from "../../network/ApiAxios";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import { useHistory } from "react-router-dom";
import imgtoData from "../../variables/imgManipulation";

const UserProfile = () => {
  const [test, settest] = useState();
  const [newage, setnewage] = useState();

  useEffect(() => {
    edittest()
    age()
    // eslint-disable-next-line
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  const history = useHistory();

  const userID = user._id;

  const edittest = async () => {
    const data = await getProfileInfo(userID);
    if (data.data.data) {
      const dat = data.data;
      settest(imgtoData(dat));
    } else {
      settest(require("assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  localStorage.setItem(
    "user",
    JSON.stringify({
      ...user,
      test,
    })
  );

  const age = () => {
    if (user.birthday === "0000-00-00") {
      // calculate age
      setnewage("Nannn");
    } else {
      var today = new Date();
      var birthDate = new Date(user.birthday);
      var agecalc = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        agecalc--;
      }
      setnewage(agecalc);
    }
  };

  const edit = (e) => {
      e.preventDefault();
      const role = JSON.parse(localStorage.getItem('user')).role
      history.push('/' + role + '/profile/edit')
  }
  return (
    <>
      <Container className="mt-9 mb-5" fluid>
        <Row className="justify-content-center">
          <Col className="order-xl-2 mb-5 mb-xl-0" xl="7">
            <Card className="card-profile shadow">
              <Row className="justify-content-center">
                <Col className="order-lg-2" lg="3">
                  <div className="card-profile-image mb-4">
                      <img alt="..." className="rounded-circle" src={test} />
                  </div>
                </Col>
              </Row>
              <CardHeader
                className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
              >
                <div className="d-flex justify-content-end">
                  <Button
                    className=""
                    color="info"
                    onClick={edit}
                    size="sm"
                  >
                    Edit Profile
                  </Button>
                </div>
              </CardHeader>
              <CardBody className="pt-0 pt-md-4">
                <div className="text-center mt-8">
                  <h3>
                    {user.name}
                    <span className="font-weight-light"> , {newage} </span>
                  </h3>
                  <div className="h5 font-weight-300">
                    <i className="ni location_pin mr-2" />
                    {user.adress}, {user.country}
                  </div>
                  <div className="h5 font-weight-300">
                    <h3>{user.position}</h3>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UserProfile;
